import { ReactNode } from 'react';
import { CampaignsTableProvider } from 'assets/js/pages/campaigns/CampaignsTableProvider';
import { ContactsTableProvider } from 'assets/js/pages/contacts/ContactsTableProvider';
import { CompaniesTableProvider } from 'assets/js/pages/contacts/companies/CompaniesTableProvider';
import { PledgesTableProvider } from 'assets/js/pages/pledges/PledgesTableProvider';
import { RecurringPaymentsTableProvider } from 'assets/js/pages/recurring-payments/RecurringPaymentsTableProvider';
import { TransactionsTableProvider } from 'assets/js/pages/transactions/TransactionsTableProvider';
import { TicketsTableProvider } from 'components/pages/tickets/TicketsTableProvider';
import { useCurrentReport } from 'customHooks/useCurrentReport';
import { ReportResource } from 'types/domain';

const ReportTableProviderStrategy = (props: { children: ReactNode }) => {
    const { children } = props;
    const { data: report } = useCurrentReport();
    const TableProvider = getTableProvider(report.resource);

    return <TableProvider>{children}</TableProvider>;
};

const getTableProvider = (resource: ReportResource) => {
    switch (resource) {
        case 'contacts':
            return ContactsTableProvider;
        case 'companies':
            return CompaniesTableProvider;
        case 'transactions':
            return TransactionsTableProvider;
        case 'tickets':
            return TicketsTableProvider;
        case 'campaigns':
            return CampaignsTableProvider;
        case 'transaction_plans':
            return RecurringPaymentsTableProvider;
        case 'pledges':
            return PledgesTableProvider;
    }
};

export { ReportTableProviderStrategy };
